import { useSelector, useDispatch } from "react-redux";
import { deleteUserAddressAsync } from "../userSlice";
import { useForm } from "react-hook-form";
import NewAddress from "../../Cart/Stepper/NewAddress";
import { useState, useEffect } from "react";
import { fetchUserAddressesAsync, addUserNewAddressAsync } from "../userSlice";
import { userAddresses } from "../userSlice";
import toast from "react-hot-toast";
import Loader from "../../../components/Common/Loader";
import { isLoadingUserSlice } from "../userSlice";

function UserAddresses() {
    const addresses = useSelector(userAddresses);
    const loading = useSelector(isLoadingUserSlice);
    const dispatch = useDispatch();
    const [newAddress, setNewAddress] = useState(false)
    const { register, handleSubmit, reset, getFieldState, formState: { errors, isValid, submitCount } } = useForm();
    const [buttonClicked, setButtonClicked] = useState(false);

    const handleRemoveAddress = (addressId) => {
        dispatch(deleteUserAddressAsync(addressId)).then(() => {
            toast.success("Address Deleted.", { id: 'success' });
        });
    }

    useEffect(() => {
        if (!addresses || addresses.length === 0) {
            dispatch(fetchUserAddressesAsync())
        }
    }, [addresses, dispatch])

    const handleNewAddress = () => {
        if (!newAddress && !buttonClicked) {
            setNewAddress(true);
            setButtonClicked(true); // Disable the button after it's clicked
        }
    }
    const cancelNewAddress = () => {
        reset();
        setNewAddress(!newAddress);
        setButtonClicked(!buttonClicked)
    }

    const validateAddress = (data) => {
        if (isValid) {
            dispatch(addUserNewAddressAsync({ ...data })).then(() => {
                cancelNewAddress(); // for reset Everything
            })
        }
    }
  return (loading ? (
    <div className="w-full flex justify-center px-2 md:px-4 py-5">
        <Loader />
    </div>) :

    <div className="space-y-4 px-3 sm:px-6 py-5">
        {(newAddress || addresses?.length > 0) && 
        <div onClick={handleNewAddress} className={`border border-gray-200 rounded-xl p-4 mb-5 shadow-sm ${!newAddress ? "cursor-pointer" : "cursor-default"}`}>
            <div className="flex items-center">
                <label className="w-5 h-5 inline-flex items-center justify-center bg-indigo-50 rounded text-base font-medium text-indigo-600 border border-indigo-100"> 
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-4 h-4"> <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" /> </svg>
                </label>
                <h1 className={`text-sm font-bold ml-3 text-indigo-600 uppercase tracking-tight`}>Add a new address</h1>
            </div>
            {newAddress &&
                <div className="px-1 sm:px-6 mt-6" id="newAddressForm">
                    <form onSubmit={handleSubmit(validateAddress)} className="w-full">
                        <NewAddress errors={errors} submitCount={submitCount} getFieldState={getFieldState} register={register} cancelNewAddress={cancelNewAddress} />
                    </form>
                </div>
            }
        </div>}
        
        <div className="grid grid-cols-1 gap-4">
            {(addresses && addresses.length > 0) ?
                addresses.map(address => (
                    <div className="border border-gray-200 rounded-xl p-4 sm:p-5 hover:border-indigo-200 transition-all bg-white" key={address.id}>
                        <div className="flex flex-col space-y-3">
                            <div className="flex justify-between items-center">
                                <div className="text-[10px] rounded-md px-2 py-0.5 font-bold text-gray-500 bg-gray-100 border border-gray-200 uppercase tracking-wider"> {address?.addressType} </div>
                                <button onClick={() => handleRemoveAddress(address.id)} className="text-gray-400 hover:text-red-600 p-1 transition-colors">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4"> <path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z" clipRule="evenodd" /> </svg>
                                </button>
                            </div>
                            <div className="flex flex-wrap items-center gap-x-3">
                                <p className="text-sm font-bold text-gray-900 uppercase">{address?.customerName}</p>
                                <p className="text-gray-900 text-sm font-bold">{address?.customerPhoneNo}</p>
                            </div>
                            <div>
                                <p className="text-gray-600 text-sm font-medium uppercase leading-relaxed">
                                    {`${address?.customerAddress}, ${address?.customerCity}, ${address?.customerState} - ${address?.customerPincode}`}
                                </p>
                            </div>
                        </div>
                    </div>
                ))
                : !newAddress && (
                    <div className="flex py-10 justify-center flex-col items-center space-y-6">
                        <img src="/no-address-found.svg" alt="no address found" className="w-44" />
                        <div className="space-y-4 text-center px-4">
                            <p className="text-xl font-bold tracking-tight text-gray-900">No Addresses Found</p>
                            <p className="text-sm text-gray-500 font-medium">Looks like you haven't saved any delivery locations yet.</p>
                            <button onClick={handleNewAddress} className="py-2.5 px-6 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-sm font-bold text-white shadow-lg transition-all">Add a New Address</button>
                        </div>
                    </div>
                )
            }
        </div>
    </div>
);

}


export default UserAddresses;


